export const EDIT_DYNAMIC_QUES_CONDITION = "edit-dynamic-ques-condition";
export const REMOVE_DYNAMIC_QUES_CONDITION = "remove-dynamic-ques-condition";
export const SET_EXPAND_SECTION = "set-expand-section";
export const EXPAND_ALL_SECTION = "expand-all-section";
export const COLLAPSE_ALL_SECTION = "collapse-all-section";